<template>
    <div class="index">
        <el-row :gutter="20">
            <el-col :span="18">
                <el-card class=" left">
                    <z-title title="常用功能"></z-title>
                    <div class="flex-w fac fjb">


                        <div class="item" v-if="menulist.indexOf('/reserve/query')>-1" @click="$router.replace('/reserve/query')">
                            <i class="iconfont icon-chaxun-copy"></i>
                            <div class="text">预定查询</div>
                        </div>
                        <div class="item" v-if="menulist.indexOf('/consultation/remind')>-1" @click="$router.replace('/consultation/remind')">
                            <i class="iconfont icon-web-icon-"></i>
                            <div class="text">咨询提醒</div>
                        </div>
                        <div class="item" v-if="menulist.indexOf('/consultation/record')>-1" @click="$router.replace('/consultation/record')">
                        <i class="iconfont icon-i-yudingtixing"></i>
                        <div class="text">场地预定记录</div>
                    </div>
                        <div class="item" v-if="menulist.indexOf('/financial/reserve')>-1" @click="$router.replace('/financial/reserve')">
                            <i class="iconfont icon-shenhe1"></i>
                            <div class="text">订单结算</div>
                        </div>
                        <div class="item" v-if="menulist.indexOf('/reserve/remind')>-1" @click="$router.replace('/reserve/remind')">
                            <i class="iconfont icon-paibantixing-copy"></i>
                            <div class="text">预定提醒</div>
                        </div>
                        <div class="item" v-if="menulist.indexOf('/consultation/record')>-1" @click="$router.replace('/consultation/record')">
                            <i class="iconfont icon-i-zixuntixing"></i>
                            <div class="text">咨询记录</div>
                        </div>
                        <div class="item" v-if="menulist.indexOf('/reserve/weddingrecords')>-1" @click="$router.replace('/reserve/weddingrecords')">
                            <i class="iconfont icon-_hunlihunqing"></i>
                            <div class="text">婚庆预定记录</div>
                        </div>


                        <div class="item " v-if="menulist.indexOf('/financial/wedding')>-1" @click="$router.replace('/financial/wedding')">
                            <i class="iconfont icon-hunqingjiudian" ></i>
                            <div class="text">婚庆结算</div>
                        </div>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="6">
                <el-card class=" right">
                    <z-title title="待办事项"></z-title>
                    <div class="flex-n fac item c-point" @click="$router.push('/consultation/remind')">
                        <template v-if="askCount">
                       <div class="text1 mr-10 textnowrap">未处理</div>
                        <div class="text2 oneline">{{askCount}}条未处理咨询任务</div>
                        </template>
                        <template v-else>
                            <div class="text3 mr-10 textnowrap">无任务</div>
                            <div class="text2 oneline">未处理咨询任务</div>
                        </template>
                    </div>
                    <div class="flex-n fac item c-point" @click="$router.push('/reserve/remind')">
                        <template v-if="orderWaitCount">
                        <div class="text1 mr-10 textnowrap">未处理</div>
                        <div class="text2 oneline">{{orderWaitCount}}条未处理预定任务</div>
                        </template>
                        <template v-else>
                            <div class="text3 mr-10 textnowrap">无任务</div>
                            <div class="text2 oneline">未处理预定任务</div>
                        </template>
                    </div>

                </el-card>
            </el-col>
        </el-row>
        <el-card class="mt-10 books">
            <z-title title="预定数量柱状图"></z-title>
            <div id="bar" style="width: 100%;height: 500px"></div>
            <el-radio-group v-model="type" size="medium" class="radio" @change="changeState">
                <el-radio-button :label="0" >日</el-radio-button>
                <el-radio-button :label="1">月</el-radio-button>
            </el-radio-group>
        </el-card>
    </div>
</template>

<script>
    import ZTitle from "../components/ZTitle";
    // 引入 ECharts 主模块
    import echarts from 'echarts/lib/echarts';
    import 'echarts/lib/chart/bar';
    import 'echarts/lib/component/tooltip';
    import 'echarts/lib/component/legend';
    import ElCard from "element-ui/packages/card/src/main";
    var clear;
    var monthday=[31,28,31,30,31,30,31,31,30,31,30,31];
    export default {
        components: {
            ElCard,
            ZTitle},
        name: "index",
        data(){
          return{
              daynum:30,//一个月的天数
              year:'',
              month:'',
              type:0,
              askCount:100,
              orderWaitCount:0,
              dataList:[],
              menulist:[],
          }
        },
        mounted(){
            let {yy,mm}=this.$TM.getDayArea();
            this.year=yy;
            this.month=mm;
            console.log(yy)
            if(yy % 4 == 0 && yy % 100 !== 0 || yy % 400 == 0){
                monthday[1]=29;
            }else{
                monthday[1]=28;
            }
            this.daynum=monthday[mm-1];
            this.getDayCount();
            this.getCount();
            this.getMenu();
        },
        methods:{
            getMenu() {
                this.$axios.get('/menu/menuRecurrenceUser/1/1').then(res => {
                    console.log('动态菜单获取', res.data.children)
                    var menulist=[];
                    for(var i in res.data.children){
                        for(var j in res.data.children[i].children){
                            menulist.push(res.data.children[i].children[j].menuAction)
                        }
                    }
                    this.menulist = menulist;
                }).catch(err => {
                    this.$message.error(err.msg)
                })
            },
            changeState(idx){
                console.log(idx)
                if(idx==0){
                    this.getDayCount();
                }else{
                    this.getMouthCount();
                }
            },
            //按天
            getDayCount(){
                this.$axios.post("/order/reportOrderCountByDay",{
                    "storeId": this.$root.getStorage('storeId'),
                    "startTime": this.year+'-'+this.month+'-1',
                    "endTime": this.year+'-'+this.month+'-'+this.daynum,
                }).then(res=>{
                    this.dataList=res.data.list;
                    this.getEcharts(0);
                }).catch(err=>{

                })
            },
            //按月
            getMouthCount(){
                this.$axios.post("/order/reportOrderCountByMonth",{
                    "storeId": this.$root.getStorage('storeId'),
                    "startTime": this.year+'-01-01',
                    "endTime": this.year+'-12-31',
                }).then(res=>{
                    this.dataList=res.data.list;
                    this.getEcharts(1);
                }).catch(err=>{

                })
            },
            getEcharts(idx){
                var name='',day=[],data=[];
                for(var i in this.dataList){
                    day.push(this.dataList[i].time);
                    data.push(this.dataList[i].count)
                }
                if(idx==0){
                    name='月'
                }else{
                    name='日'
                }
                // 基于准备好的dom，初始化echarts实例
                var myChart = echarts.init(document.getElementById('bar'));
// 绘制图表
                myChart.setOption({
                    tooltip: {},
                    xAxis: {
                        name:name,
                        data: day
                    },
                    yAxis: {},
                    series: [{
                        name: '预定',
                        type: 'bar',
                        data: data,
                        color:'#8080ff',
                        itemStyle: {
                            normal: {
                                label: {
                                    show: true, //开启显示
                                    position: 'top', //在上方显示
                                    textStyle: { //数值样式
                                        color: '#8080ff',
                                        fontSize: 12
                                    }
                                }
                            }
                        },
                    }]
                });
                clear=setInterval(()=>{
                    myChart.resize();
                },500)
            },
            getCount(){
                this.$axios.post('/preUserAsk/todoCount',{
                    storeId:this.$root.getStorage('storeId')
                }).then(res=>{
                    console.log(res.data)
                    this.askCount=res.data.askCount;
                    this.orderWaitCount=res.data.orderWaitCount;
                }).catch(err=>{
                    this.$message.error(err.msg)
                })
            },

        },
        beforeDestroy(){
            clearInterval(clear);
        }
    }
</script>

<style scoped lang="scss">
    @import "../common/css/common";
.index{
    .left{
        height:330px;
        .item{
            @extend .c-point;
            width: 22%;
           margin-top: 20px;
            text-align: center;
            .iconfont{
                color: #5295e7;
            }
            i{
                font-size: 70px;
            }
            .text{
                font-size: 14px;
                color: #333;
                margin-top: 10px;
            }
        }
    }
    .right{
        height:330px;
        .item{
            height: 50px;

            .text1{
                color: white;
                background: #d9001b;
                border-radius: 10px;
                font-size: 13px;
                padding: 2px 5px;
            }
            .text2{
                font-size: 15px;
                color: #666;
            }
            .text3{
                color: white;
                background: #04e414;
                border-radius: 10px;
                font-size: 13px;
                padding: 2px 5px;
            }
        }
    }
    .books{
        position: relative;
        .radio{
           position: absolute;
            right: 80px;
            top: 20px;
        }
    }
}
</style>